/* eslint-disable dot-notation */
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Table } from 'primeng/table';
import { TokenService } from 'viggo-sistemas-core-web';

import { IProdutoVariacao } from '@app/modules/produto/model';
import { ProdutoVariacaoService } from '@app/modules/produto/services/produto-variacao-service/produto-variacao.service';
import {
  IVariacao,
  IVariacaoItem
} from '@app/modules/variacao-produtos/model/variacao.model';
import { Utils } from '@app/shared/helpers/utils';
import { ValidadorSettingsDomain } from '@app/shared/utils/validar_settings_domain';

@Component({
  selector: 'app-table-produto-variacoes',
  templateUrl: 'app-table-produto-variacoes.component.html',
  styleUrls: ['app-table-produto-variacoes.component.scss'],
  providers: [ProdutoVariacaoService]
})
export class AppTableProdutosVariacaoComponent {
  @Input() produto_existe = false;
  @Input() valor_minimo: number;
  @Input() quantidade: number;
  @Input() produtos: IProdutoVariacao[] = [];
  @Input() showProdutos = false;
  @Input() updateRowsVariacao = false;
  @Output() onRemoveAllProdutosVariacao = new EventEmitter<void>();
  @Output() onRemoveProdutoVariacao = new EventEmitter<IProdutoVariacao>();

  @Input() variacoes: IVariacao[] = [];
  @Input() showVariacoes = false;
  @Output() onRemoveAllVariacao = new EventEmitter<void>();
  @Output() onRemoveAllVariacaoItem = new EventEmitter<string>();

  @Output() onRemoveVariacao = new EventEmitter<IVariacao>();
  @Output() onRemoveVariacaoItem = new EventEmitter<IVariacaoItem>();

  @Output() onUpdateProduto = new EventEmitter<void>();

  clonedProducts: { [s: string]: IProdutoVariacao } = {};
  filterActive = false;
  filterItensActive = false;

  @ViewChild('filterInput', { read: ElementRef }) filterInput: ElementRef<
    HTMLInputElement
  >;

  @ViewChild('filterInputItens', { read: ElementRef })
  filterInputItens: ElementRef<HTMLInputElement>;

  constructor(
    public matSnackBar: MatSnackBar,
    protected tokenService: TokenService,
    protected produtoVariacaoService: ProdutoVariacaoService
  ) {}

  filter(text: string, table: Table, filterItens: boolean) {
    if (text === '') {
      if (!filterItens) this.filterActive = false;
      else this.filterItensActive = false;
      table.filterGlobal(text, 'contains');
    } else {
      if (!filterItens) this.filterActive = true;
      else this.filterItensActive = true;
      table.filterGlobal(text, 'contains');
    }
  }

  clear(table: Table, filterItens: boolean) {
    if (!filterItens) {
      this.filterActive = false;
      this.filterInput.nativeElement.value = '';
    } else {
      this.filterItensActive = false;
      this.filterInputItens.nativeElement.value = '';
    }
    table.clear();
  }

  onRowEditInit(produto: IProdutoVariacao) {
    localStorage.setItem('PRODUTO_BACKUP', JSON.stringify(produto));
    localStorage.setItem(
      'PRODUTOS_VARIACAO_BACKUP',
      JSON.stringify(this.produtos)
    );
    this.clonedProducts[produto.posicao as number] = { ...produto };
  }

  onRowEditSave(produto: IProdutoVariacao) {
    let qtd = 0;
    this.produtos.forEach(it => {
      qtd += Utils.replaceCommaToDot(it.quantidade);
    });
    produto.quantidade = Utils.replaceCommaToDot(produto.quantidade);
    produto.valor = Utils.replaceCommaToDot(produto.valor);
    if (produto.valor < Utils.replaceCommaToDot(this.valor_minimo)) {
      this.matSnackBar.open(
        'Valor do produto variação não pode ser menor que o valor mínimo do produto!',
        'X',
        {
          panelClass: ['msg-error'],
          horizontalPosition: 'right',
          verticalPosition: 'top',
          duration: 3000
        }
      );
      const prod_backup = JSON.parse(localStorage.getItem('PRODUTO_BACKUP'));
      this.produtos.forEach(produto => {
        if (this.produto_existe) {
          if (produto.posicao === prod_backup.posicao) {
            produto.valor = prod_backup.valor;
          }
        } else {
          produto.valor = Utils.replaceCommaToDot(this.valor_minimo);
        }
      });
    }
    // else if (
    //   qtd !== Utils.replaceCommaToDot(this.quantidade) &&
    //   this.usaControleEstoque
    // ) {
    //   this.matSnackBar.open(
    //     'Quantidade de estoque das variações deve ser igual a do produto!',
    //     'X',
    //     {
    //       duration: 3000,
    //       horizontalPosition: 'right',
    //       verticalPosition: 'top',
    //       panelClass: ['msg-error']
    //     }
    //   );
    //   const prod_backup = JSON.parse(localStorage.getItem('PRODUTO_BACKUP'));
    //   this.produtos.forEach(produto => {
    //     if (this.produto_existe) {
    //       if (produto.posicao === prod_backup.posicao) {
    //         produto.quantidade = prod_backup.quantidade;
    //       }
    //     } else {
    //       produto.quantidade = 0;
    //     }
    //   });
    // }
    else {
      delete this.clonedProducts[produto.posicao as number];
      this.onUpdateProduto.emit();
    }
  }

  onRowEditCancel(produto: IProdutoVariacao, index: number) {
    this.produtos[index] = this.clonedProducts[produto.posicao as number];
    delete this.clonedProducts[produto.posicao as number];
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  get usaControleEstoque() {
    const domain = this.tokenService.getDomain();
    domain.settings = new ValidadorSettingsDomain(
      domain.settings
    ).getDomainSettingsBody(domain.settings) as any;
    return domain.settings['regras']['controle']['produto'][
      'controle_estoque'
    ] !== undefined
      ? domain.settings['regras']['controle']['produto']['controle_estoque']
      : false;
  }

  /**
   * Verifica se o SKU inserido já está cadastrado
   */
  public checarSKU(produto_variacao: IProdutoVariacao): void {
    if (produto_variacao.sku) {
      this.produtoVariacaoService
        .getEntitiesByParams(
          `produto.domain_id=${this.tokenService.getDomain().id}&sku=${
            produto_variacao.sku
          }&page=0&page_size=1&list_options=ACTIVE_ONLY`,
          undefined,
          true
        )
        .subscribe(resultado => {
          if (resultado.data && resultado.data.length) {
            const produto = resultado.data[0];
            if (produto.id === produto_variacao.id) return;
            this.showErroSku();
          } else {
            const produtos_backup = JSON.parse(
              localStorage.getItem('PRODUTOS_VARIACAO_BACKUP')
            );
            const prod_found = produtos_backup.find(
              pd => produto_variacao.sku === pd.sku
            );
            if (prod_found.posicao !== produto_variacao.posicao)
              this.showErroSku();
          }
        });
    }
  }

  /**
   * Exibe a msg de erro do SKU duplicado
   */
  showErroSku() {
    const prod_backup = JSON.parse(localStorage.getItem('PRODUTO_BACKUP'));
    this.produtos.forEach(produto => {
      if (produto.posicao === prod_backup.posicao) {
        produto.sku = prod_backup.sku;
      }
    });
    this.matSnackBar.open(
      'SKU já existe para um produto variação, informe outro!',
      'X',
      {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['msg-error']
      }
    );
  }
}
